import { CancellationReasonsServiceInterface } from 'domain/services';
import { GetAllCancellationReasonsUseCaseInterface } from 'domain/usecases';

export class CancellationReasonsService
  implements CancellationReasonsServiceInterface
{
  constructor(
    private readonly _getAllCancellationReasons: GetAllCancellationReasonsUseCaseInterface,
  ) {}

  async getAllCancellationReasons(): Promise<GetAllCancellationReasonsUseCaseInterface.Result> {
    return await this._getAllCancellationReasons.execute();
  }
}
